export var GRANT_TYPE;
(function (GRANT_TYPE) {
    GRANT_TYPE["CLIENT_CREDENTIALS"] = "client_credentials";
    GRANT_TYPE["REFRESH_TOKEN"] = "refresh_token";
    GRANT_TYPE["PASSWORD"] = "password";
})(GRANT_TYPE || (GRANT_TYPE = {}));
export var LOCALE_TYPE;
(function (LOCALE_TYPE) {
    LOCALE_TYPE["FR"] = "fr";
    LOCALE_TYPE["EN"] = "en";
    LOCALE_TYPE["PT"] = "pt";
    LOCALE_TYPE["ES"] = "es";
})(LOCALE_TYPE || (LOCALE_TYPE = {}));
